<template>
  <section class="content">
    <div class="row center-block">
      <!--<h2>Data tables</h2>-->
      <div class="col-md-12">
        <ad-form :info="info"/>
      </div>
    </div>
  </section>
</template>

<script>
import adForm from './Temp/AdFormTemp.vue'

export default {
  name: 'Tables',
  data () {
    return {
      info: {
        name: '光復店',
        des: '滿200外送'
      }
    }
  },
  components: {
    'ad-form': adForm
  },
  computed: {
    checkInput () {
      return this.$parent.checkInput
    },
    getDataH () {
      return this.$parent.getDataH
    },
    getData () {
      return this.$parent.getData
    }
  }
}
</script>



// WEBPACK FOOTER //
// UpAd.vue?67207fc3